import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_ATTACHFILE_FULFILLED = "FETCH_ATTACHFILE_FULFILLED";
export const FETCH_ATTACHFILE_REJECTED = "FETCH_ATTACHFILE_REJECTED";
export const FETCH_ATTACHFILE_PENDING = "FETCH_ATTACHFILE_PENDING";
export const RESET_ATTACHFILE = "RESET_ATTACHFILE";
export const FETCH_ATTACHFILE_PROGRESS = "FETCH_ATTACHFILE_PROGRESS";

export function attachFile(file, applicationId) {
    
    const token = localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("applicationId", applicationId);

    return (dispatch) => {
        dispatch({
            type: "FETCH_ATTACHFILE",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v3/second-opinion/attach-file-to-application`,
                data: formData,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "multipart/form-data",
                },
                onUploadProgress: function (progressEvent) {
                    let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
                    dispatch({
                        type: FETCH_ATTACHFILE_PROGRESS,
                        payload: percentCompleted
                    });
                }
            }).then((result) => result.data),
        });
    };
}

export function resetAttachFile() {
    return (dispatch) => {
        dispatch({
            type: "RESET_ATTACHFILE",
        });
    };
}